/**
 * A module to export enumerations of available actions for GeoApi
 * This actions are used to send commands to internal api and called by
 * actionCreators
 *
 * @module geo/actions
 * @internalapi
 * @internalApi
 * @private
 */

/**
 * Enumerate all available actions 
 * @since v 2.0.1
 */
export enum TypeKeyActions {
  _null = '__null',
  GEO_API_PROXY_READY = 'GEO_API_PROXY_READY',
  INIT_APP_TYPE = 'INIT_APP',
  ENABLE_FUNCTIONALITY = 'ENABLE_FUNCTIONALITY',
  LISTEN_MAP_EVENTS = 'LISTEN_MAP_EVENTS',
  ADD_MARKERS = 'ADD_MARKERS',
  REMOVE_MARKERS = 'REMOVE_MARKERS',
  GO_TO_MARKER = 'GO_TO_MARKER',
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_OUT = 'ZOOM_OUT',
  PAN_TO = 'PAN_TO',
  GO_TO_INIT_EXTENT = 'GO_TO_INIT_EXTENT',
  GO_TO_EXTENT = 'GO_TO_EXTENT',
  GO_TO_POINT = 'GO_TO_POINT',
  ZOOM_TO_SCALE = 'ZOOM_TO_SCALE',
  DISABLE_FUNCTIONALITY = 'DISABLE_FUNCTIONALITY',
  SET_ENTRIES_VISIBILITIES = 'SET_ENTRIES_VISIBILITIES',
  SET_BASELAYERS_VISIBILITIES = 'SET_BASELAYERS_VISIBILITIES',
  SERVICE_GET_IMAGE_MAP = 'SERVICE_GET_IMAGE_MAP',
  SET_SELECTION_LAYERS = 'SET_SELECTION_LAYERS',
  RESET_SELECTION = 'RESET_SELECTION',
  ADD_TO_SELECTION = 'ADD_TO_SELECTION',
  REMOVE_FROM_SELECTION = 'REMOVE_FROM_SELECTION',
  SET_GLOBAL_PARAMETER_VALUE = 'SET_GLOBAL_PARAMETER_VALUE',
  SET_FILTER_HISTORY_TIMESTAMP = 'SET_FILTER_HISTORY_TIMESTAMP',
  SET_COMPONENTS_STATE = 'SET_COMPONENTS_STATE',
  DISPATCH_DATA_REFRESH_EVENT = 'DISPATCH_DATA_REFRESH_EVENT',
  SERVICE_GET = 'SERVICE_GET',
  SERVICE_CALL_METHOD = 'SERVICE_CALL_METHOD',
  SERVICE_EXECUTE_SEARCH= 'SERVICE_EXECUTE_SEARCH',
  SERVICE_CALL_REST = 'SERVICE_CALL_REST',
  SERVICE_FEATURE_TRANSACTION='SERVICE_FEATURE_TRANSACTION',
  REGISTER_EXTENSION = 'REGISTER_EXTENSION',
  ADD_MENU_ITEM = 'ADD_MENU_ITEM',
  CLEAR_SERVICE='CLEAR_SERVICE',
  OTHER_ACTION = '__any_other_action_type__'
}
